import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-mobileContentTypeShape",
  "use": "svg-icon-mobileContentTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-mobileContentTypeShape\"><g fill-rule=\"evenodd\"><path d=\"M2 2h12V0H2z\" /><path d=\"M2 14h2V1.999H2zm10 0h2V1.999h-2z\" /><path d=\"M8 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm-6 1h12v-4H2v4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol